<template>
  <div>
    <a target="_blank" rel="noopener noreferrer" href="https://consultas.neuland.com.py/servlet/ahrconslogin">
      <div class="text-primary flex items-center mb-8" >
        <Link class="fill-current shadow p-1 rounded bg-background w-5 h-5 mr-1" />
        <h5 class="heading uppercase tracking-tight" >versión detallado</h5>
      </div>
    </a>
    <div class="section vertical min-h-full">
      <h4 class="header">{{account && account.name || 'CONSULTA SALDO'}}</h4>
      <transition name="fade" mode="out-in">
        <div class="mt-12 mb-8" v-if="account && account.failed == true">
          <h3 class="mb-3">Algo salió mal</h3>
          <h5 class="mb-3">Esta cuenta no fue encontrada</h5>
        </div>
        <Balance
          v-else
          v-bind:loading="rotate"
          v-bind:actual_balance="account && account.actual_balance || 0"
          v-bind:initial_balance="account && account.initial_balance || 0"
        />
      </transition>
      <Accounts list="accountList.list"/>
      <Overdraft
        class="mb-6"
        v-bind:balance="account && account.actual_balance || 0"
        v-bind:overdraft="account && account.overdraft || 0"
        v-bind:additional_overdraft="account && account.additional_overdraft || 0"
        v-bind:authorized_overdraft="account && account.authorized_overdraft || 0"
        v-bind:authorized_overdraft_expiry="account && account.authorized_overdraft_expires || ''"
      />
    </div>
    <button v-on:click="logout" class="btn">Cerrar Sesión</button>
  </div>
</template>

<script>
// @ is an alias to /src
import Accounts from "@/components/Accounts.vue";
import Balance from "@/components/Balance.vue";
import Overdraft from "@/components/Overdraft.vue";
import Link from "@/icons/link.svg";
import { setTimeout } from "timers";

export default {
  name: "account",
  components: {
    Accounts,
    Balance,
    Overdraft,
    Link
  },
  data() {
    return {
      rotate: false
    };
  },
  computed: {
    isFailed() {
      return this.$store.state.account.isFailed;
    },
    isFetching() {
      return this.$store.state.account.isFetching;
    },
    account() {
      return this.$store.getters.getAccount({
        id: this.$route.params.id,
        sub_id: this.$route.params.sub_id
      });
    },
    accountsListState() {
      return this.$store.state.accounts.isFetching;
    }
  },
  methods: {
    logout: function() {
      this.$store.dispatch({
        type: "logout"
      });
      setTimeout(() => {
        this.$router.push("/login");
      }, 1000);
    },
    sleep: function(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    loadAllAccounts() {
      console.log("reload accounts");
      this.$store.state.accounts.list.map(item => {
        this.$store.dispatch({
          type: "fetchAccount",
          data: { id: item.id, sub_id: item.sub_id }
        });
      });
    }
  },
  created() {
    this.poll = setInterval(() => this.loadAllAccounts(), 600000);
  },
  beforeDestroy() {
    clearInterval(this.poll);
  },
  watch: {
    accountsListState() {
      // preload the other accounts
      if (
        this.accountsListState == false &&
        this.$store.state.accounts.list.length > 0
      ) {
        this.loadAllAccounts();
      }
    },
    isFetching() {
      if (this.isFetching == true) {
        this.rotate = true;
      } else {
        setTimeout(() => {
          this.rotate = false;
        }, 1000);
      }
    }
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
